import React from 'react'
import {cx} from '@emotion/css'

import {SelectionCard} from '@vio/atlas/SelectionCard'

interface FacetCardProps {
  icon: React.ReactNode
  label: React.ReactNode
  isSelected: boolean
  onSelectCard: () => void
}
export const FacetCard: React.FC<FacetCardProps> = ({
  icon,
  label,
  isSelected,
  onSelectCard
}) => {
  return (
    <SelectionCard
      variant="checkbox"
      name={label as string}
      selected={isSelected}
      withControlButton
      onChange={() => onSelectCard()}
      className={cx(!isSelected && '--hide-checkbox')}
      prefix={icon}
      isVertical
      title={label}
    />
  )
}
